export enum MessageType {
  success = 'success',
  warning = 'warning',
  error = 'error',
  information = 'information'
}
